export default __webpack_public_path__ + "assets/images/c68c8375ab0f0ec3c010dcee3fa22ce6.svg";